'use strict';
// ordered most broadly-useful → most stylised (the dropdown reads top-to-bottom)
const styles = {
  clean: require('./clean'),
  linger: require('./linger'),
  pop: require('./pop'),
  tape: require('./tape'),
  larsen: require('./larsen'),
  px7: require('./px7'),
  kraft: require('./kraft'),
  brat: require('./brat'),
  ruckclub: require('./ruckclub'),
  utypisk: require('./utypisk'),
  chrome: require('./chrome'),
  neon: require('./neon'),
  vhs: require('./vhs'),
};
function get(id) {
  const s = styles[id];
  if (!s) throw new Error('Unknown style "' + id + '". Available: ' + Object.keys(styles).join(', '));
  return s;
}
function list() { return Object.values(styles).map(s => ({ id: s.id, label: s.label })); }
module.exports = { styles, get, list };
